module.exports = __webpack_public_path__ + "images/r-vishnevskii-6319bd.jpg";